import { ReactNode } from "react";
import { numberFormatter } from "@common/helpers/number";
import { BulkSelectionControl } from "@design-system/BulkSelectionControl/BulkSelectionControl";
import { Button } from "@design-system/Button/Button";
import { CommandIsland } from "@design-system/CommandIsland/CommandIsland";
import commandIslandStyles from "@design-system/CommandIsland/CommandIslandVariants.module.scss";
import { HStack } from "@design-system/HStack/HStack";
import { Shortcut } from "@design-system/Shortcut/Shortcut";
import { Tooltip } from "@design-system/Tooltip/Tooltip";

interface Props {
    selectedCount: number;
    selectableCount: number;
    onClearSelection: () => void;
    onSelectAll: () => void;
    onOpenActions: () => void;
    reviewAction?: ReactNode;
}

export const AccrualImporterDraftsCommandBar: React.FC<Props> = ({
    selectedCount,
    selectableCount,
    onClearSelection,
    onSelectAll,
    onOpenActions,
    reviewAction,
}) => {
    if (selectedCount === 0) {
        return null;
    }

    return (
        <CommandIsland
            sticky
            className={commandIslandStyles.bulkActionsStickyFooter}
        >
            <HStack gap={8}>
                <BulkSelectionControl
                    size="md"
                    selectedCount={selectedCount}
                    onClearSelection={onClearSelection}
                />
                {selectedCount < selectableCount && (
                    <Button variant="primary" size="md" onClick={onSelectAll}>
                        Select all {numberFormatter.format(selectableCount)}
                    </Button>
                )}
            </HStack>
            <HStack gap={8}>
                <Tooltip content="Open bulk actions">
                    <Button
                        variant="primary"
                        size="md"
                        onClick={onOpenActions}
                        rightIcon={
                            <span data-slot-box="">
                                <Shortcut keys="mod+k" />
                            </span>
                        }
                    >
                        Actions
                    </Button>
                </Tooltip>
                {reviewAction}
            </HStack>
        </CommandIsland>
    );
};
